import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { ArrowButton } from './ui/ArrowButton';
import { Reveal } from './ui/Reveal';
import { SectionLabel } from './ui/SectionLabel';
import { SplitText } from './ui/SplitText';
import { faqItems } from '../data/faq';
import { EASE_OUT } from '../utils/motion';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper py-24 lg:py-36" data-id="element-51" data-mp="28aruu4nf383i">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12" data-id="element-52" data-mp="289hxjhoe23xx">
        <div className="lg:col-span-5" data-id="element-53" data-mp="1uibrt3uina2l">
          <Reveal data-id="element-54" data-mp="1uhaaihmwprcf">
            <SectionLabel data-id="element-55" data-mp="1zi7tuxjnkrfi">Questions fréquentes</SectionLabel>
          </Reveal>
          <h2 className="mt-6 max-w-md text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-56" data-mp="1zg4tpkosdhx2">
            <SplitText text="Tout ce que vous voulez savoir avant de commencer." data-id="element-57" data-mp="2ryiikus59tk0" />
          </h2>
          <Reveal delay={0.15} data-id="element-58" data-mp="14vacm00gx13f">
            <p className="mt-6 max-w-sm leading-relaxed text-muted" data-id="element-59" data-mp="14wbykzj0v7zx">
              Une autre question ? Le plus simple est d’en parler de vive voix.
            </p>
            <ArrowButton to="/contact" className="mt-8" data-id="element-60" data-mp="1el3nszwp7e75">
              Poser une question
            </ArrowButton>
          </Reveal>
        </div>

        <ul className="border-t border-ink/15 lg:col-span-7" data-id="element-61" data-mp="19tlla7f115k2">
          {faqItems.map((item, i) => {
          const isOpen = open === i;
          return <li key={item.question} className="border-b border-ink/15" data-id="element-62" data-mp="1jkpzh4wvomdu" data-mpi={i}>
                <h3 data-id="element-63" data-mp="1xjze405fr8fp">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-medium" data-id="element-64" data-mp="1xkhjpndzmz0a">
                    {item.question}
                    <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full transition-[background-color,color,transform] duration-200 ease-out-strong ${isOpen ? 'rotate-45 bg-ink text-white' : 'bg-ink/[0.06] text-ink'}`} aria-hidden="true" data-id="element-65" data-mp="1y939tujaztzs">
                      <PlusIcon className="h-4 w-4" data-id="element-66" data-mp="2c6rrkti2ql0m" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-67" data-mp="2m723masdhme7">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: EASE_OUT
              }} className="overflow-hidden" data-id="element-68" data-mp="2m4pendo76brn">
                      <p className="max-w-2xl pb-6 pr-12 leading-relaxed text-muted" data-id="element-69" data-mp="34vgwz4q5xci6">{item.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}